<template>
  <div class="component">
    <testPortalBanner v-if="isTestPortal" />
    <mainHeader></mainHeader>
    <sideMenu :studyData="studyData" :isTestPortal="isTestPortal"></sideMenu>
    <div class="container-fluid notify-container pb-30">
      <div class="row mb-12">
        <div class="mr-auto mt-10 notifications" v-translate:notification_list_header_title="lang">
          Notifications
        </div>
        <div>
          <ul class="nav box">
            <li class="nav-item dropdown pl-left">
              <div class="nav-link" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                <input id="filterTextId" v-model="filterText" class="mr-right Filter-by-status-1 caret-down-icon" />
              </div>
              <div class="dropdown-menu cursor_pointer">
                <a class="dropdown-item All-notifications" @click="onChangeFilter(showAllFilter)">Show All</a>
                <div class="dropdown-divider"></div>
                <input class="Filter-by-status ml-25" disabled value="Filter by status" />
                <a class="dropdown-item All-notifications cursor_pointer" v-for="(item, index) in filterList" :key="index" @click="onChangeFilter(item)">{{ item.notificationText }}</a>
                <div class="dropdown-divider"></div>
                <input class="Filter-by-status ml-25" disabled value="Filter by notifcation type" />
                <a class="dropdown-item All-notifications cursor_pointer" v-for="(item, index) in profileNotificationList" :key="index" @click="onChangeFilter(item)">{{ item.notificationText }}</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div fluid class="row notification-grid">
        <div class="col-12">
          <table class="table table-borderless">
            <thead class="fs-12">
              <tr>
                <th class="head-section" :class="field.class" v-for="(field, index) in notificationListFields" :key="index">
                  <span class="pr-3 position-relative" v-if="field.key == 'notificationText'">
                    <span>{{ field.label }}</span>
                  </span>
                  <span class="pr-3 position-relative" v-if="field.key != 'notificationText'">
                    <span @click="sortField(field)"
                      >{{ field.label }}
                      <span class="sortUp" v-if="field.key != 'notificationText'" :class="{ 'disable-icon': !field.ascOrder }"><i class="fa fa-angle-up" aria-hidden="true"></i></span>
                      <span class="sortDown" v-if="field.key != 'notificationText'" :class="{ 'disable-icon': !field.descOrder }"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                    </span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody v-if="notificationList.length > 0">
              <tr v-for="item in notificationList" :key="item.userPortalNotificationId" :class="{ 'unread-row': !item.read }">
                <td class="pt-12">
                  <span v-if="!item.read" class="pl-12">
                    <img src="static/img/notification/On.png" class="ICNNavNotificationOn" />
                  </span>
                </td>
                <td class="pt-12 participant-Id text-info" v-if="(item.notificationType === 'PARTICIPANT_TRANSFER' || item.notificationType === 'PARTICIPANT_TRANSFER_INITIATE' || item.notificationType === 'PARTICIPANT_TRANSFER_STATUS') && item.participantCount > 1">
                  <span @click="unreadNotification(item)"> Participants </span>
                  <span class="numberID">{{ item.participantCount }}</span>
                </td>
                <td class="pt-12 participant-Id" v-else :class="{ 'text-info': item.userDefinedParticipantId }">
                  <a v-if="item.userDefinedParticipantId" @click="goToParticipantProfile(item)">
                    <span>{{ convertArrayStringHtml("", item.userDefinedParticipantId) }}</span>
                  </a>
                </td>
                <td class="pt-12 thread-Id text-info cursor_pointer" v-if="(item.notificationType !== 'PARTICIPANT_TRANSFER' && item.notificationType !== 'PARTICIPANT_TRANSFER_INITIATE' && item.notificationType !== 'PARTICIPANT_TRANSFER_STATUS') || item.participantCount < 2">
                  <span v-if="!item.showMore" @click="goToParticipantProfile(item)">{{ item.participantId.slice(0, 11) }}...</span>
                  <a v-if="!item.showMore" class="cursor_pointer table-content-color text-info fs-12" @click="toggleShowMore(item)">
                    <u>Show</u>
                  </a>
                  <span v-if="item.showMore" @click="goToParticipantProfile(item)">{{ item.participantId }}</span>
                  <a v-if="item.showMore" class="cursor_pointer table-content-color text-info fs-12" @click="toggleShowMore(item)">
                    <u>Less</u>
                  </a>
                </td>
                <td class="pt-12" v-else></td>
                <td
                  class="pt-12"
                  :class="{
                    'text-info': !item.read,
                    cursor_pointer: !item.read
                  }"
                  v-if="item.notificationType === 'PARTICIPANT_TRANSFER'"
                >
                  <span @click="transferApprovalModal(item)" v-html="item.notificationText"></span>
                </td>
                <td class="pt-12" v-else>
                  <span v-html="item.notificationText"></span>
                </td>
                <td class="pt-12">
                  <span v-if="notificationDateFilter(item.notificationDeliveryTime) == 'Today'"><b>Today</b></span>
                  <span v-else>{{ item.notificationDeliveryTime | customDateFilter }}</span>
                </td>
              </tr>
            </tbody>
            <tbody v-if="notificationList.length == 0">
              <div class="emptyGrid" v-if="enableNoData">
                No notifications available to view
              </div>
            </tbody>
          </table>
          <div class="pb-5 pl-15 bottom-0" v-if="notificationList && notificationList.length">
            <div class="row display-inline-flex">
              <div @click="prevPage(pageNum, totalPages)" class="arrow-icon cursor_pointer" :class="{ disabledPagination: pageNum <= 1 }">
                <i class="fa fa-angle-left pt-3"></i>
              </div>
              <div class="pagination pt-3 pr-5">{{ pageNum }}</div>
              <div class="pagination2 pt-3 pr-5">of {{ totalPages }}</div>
              <div @click="nextPage(pageNum, totalPages)" class="arrow-icon pt-3 cursor_pointer" :class="{ disabledPagination: pageNum >= totalPages }">
                <i class="fa fa-angle-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- transfer participant  modal -->
    <div class="modal fade" id="transferParticipantModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p class="modal-title m-0">
              The following participants are being transfered to your site from
            </p>
            <p class="modal-title m-0 pt-5 pb-10">
              <b>{{ this.transferApprovalDetails.fromSiteId }} - {{ this.transferApprovalDetails.fromSiteName }}</b>
            </p>
            <div class="transfer-table-wrapper">
              <div class="tarnsfer-table-div">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Participant ID</th>
                      <th scope="col">THREAD ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in this.transferApprovalDetails.participantsIdAssociatedThreadIdDTOs" :key="index">
                      <td v-if="item.participantId" v-html="convertArrayStringHtml('', item.participantId)"></td>
                      <td v-else>{{ item.participantId }}</td>
                      <td>{{ item.threadId }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <p class="input-title m-0 pb-5 pt-10">Reason for Transfer</p>
            <input type="text" id="exampleFormControlInput1" v-model="this.transferApprovalDetails.reason" class="form-control" disabled />
            <div class="d-flex pt-20 justify-content-between">
              <div class="btn btn-decline" @click="transferResponse(false)">
                Decline Transfer
              </div>
              <div class="btn btn-accept" @click="transferResponse(true)">
                Accept Transfer
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Already accepted/Declined transfer modal-->
    <div class="modal fade" id="acceptDeclinedModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p class="modal-title m-0"></p>
            <table class="table">
              <thead></thead>
              <tbody>
                <strong>Transfer has been already {{ this.transferStatus }} by {{ this.transferApprovalDetails.username }}</strong>
              </tbody>
            </table>
            <div class="pt-20 text-center">
              <div class="btn btn-ok" @click="alreadyTransferAcceptDecline()">
                Ok
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mainHeader from "../common/main-header";
import sideMenu from "../common/side-menu";
import testPortalBanner from "../common/test-portal-banner";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import moment from "moment";
import _ from "lodash";
import { mapGetters } from "vuex";
import localStorageService from "@/services/localStorage";
import { PORTAL_TYPE } from "@/constants/common";
import { TEST_PORTAL_SUFFIX } from "@/constants/config";
export default {
  components: {
    mainHeader,
    sideMenu,
    testPortalBanner
  },
  data() {
    return {
      studyData: {},
      allNotificationDetails: {},
      transferApprovalDetails: {},
      currentClickedNotification: {},
      isSiteTeam: true,
      siteId: "",
      studyId: this.$route && this.$route.params && this.$route.params.studyId ? this.$route.params.studyId : "",
      userId: "",
      transferStatus: "",
      pageNum: 1,
      totalPages: 1,
      pageSize: 15,
      sortValue: "",
      sortOrder: "desc",
      filter: "",
      filterText: "Filter",
      profileNotificationList: [],
      notificationList: [],
      tempUserId: "",
      loading: false,
      enableNoData: false,
      showAllFilter: {
        notificationTypeId: "",
        notificationText: "Show All"
      },
      filterList: [
        {
          id: 1,
          notificationTypeId: "unread",
          notificationText: "Show Unread"
        },
        {
          id: 2,
          notificationTypeId: "read",
          notificationText: "Show Read"
        }
      ],
      notificationListFields: [
        {
          key: "isRead",
          type: "string",
          label: "READ",
          class: "heading-color cursor_pointer width-70 pl-15",
          ascOrder: false,
          descOrder: false,
          currentOrder: null
        },
        {
          key: "userDefinedParticipantId",
          type: "string",
          label: "PARTICIPANT ID",
          class: "heading-color cursor_pointer width-119 pl-10",
          ascOrder: false,
          descOrder: false,
          currentOrder: null
        },
        {
          key: "participantId",
          type: "string",
          label: "THREAD ID",
          class: "heading-color cursor_pointer width-180 pl-10",
          ascOrder: false,
          descOrder: false,
          currentOrder: null
        },
        {
          key: "notificationText",
          type: "string",
          label: "NOTIFICATION",
          class: "heading-color cursor_pointer width-540 pl-10",
          ascOrder: false,
          descOrder: false,
          currentOrder: null
        },
        {
          key: "notificationDeliveryTime",
          type: "date",
          label: "DAY NOTIFIED",
          ascOrder: false,
          descOrder: false,
          class: "heading-color cursor_pointer pl-10",
          currentOrder: null
        }
      ],
      saveInterval: null
    };
  },
  props: {
    isTestPortal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["user"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  beforeDestroy() {
    clearInterval(this.saveInterval);
  },
  mounted() {
    this.checkRoleAndGetDetails();
    this.getStudyDetails();
    this.saveInterval = setInterval(() => {
      this.checkRoleAndGetDetails();
    }, 60000);
  },
  methods: {
    // Get all study team notification list
    getStudyDetails() {
      this.$api.getStudyDataFact(this.$route.params.studyId).then(response => {
        this.studyData = response.body;
      });
    },
    transferApprovalModal(item) {
      if (item.read) {
        return false;
      }
      const param = {
        studyId: this.$route.params.studyId,
        transferId: item.taskId
      };
      this.currentClickedNotification = item;
      this.$api.getPendingTransferList(param).then(res => {
        this.transferApprovalDetails = res.data;
        if (this.transferApprovalDetails.status === "TRANSFER_ACCEPTED" || this.transferApprovalDetails.status === "TRANSFER_DECLINED") {
          this.transferStatus = this.transferApprovalDetails.status === "TRANSFER_ACCEPTED" ? "Accepted" : "Declined";
          window.$("#acceptDeclinedModal").modal("show");
        } else {
          window.$("#transferParticipantModal").modal("show");
        }
      });
    },
    transferResponse(accepted) {
      const payload = {
        status: accepted ? "TRANSFER_ACCEPTED" : "TRANSFER_DECLINED",
        reviewReason: this.transferApprovalDetails.reason
      };
      const studyId = this.$route.params.studyId;
      this.$api.transferApproval(studyId, this.currentClickedNotification.taskId, payload).then(res => {
        window.$("#transferParticipantModal").modal("hide");
        this.$toastr.success(res.body.msg);
        if (!this.currentClickedNotification.read) {
          this.$api.markAsReadUserNotification(this.currentClickedNotification.userPortalNotificationId).then(
            () => {
              nprogress.done();
              this.$api.getUnreadCount(this.$route.params.studyId, this.user.id).then(
                response => {
                  this.unreadCount = response.body.unreadCount;
                  this.$forceUpdate();
                  this.getSiteNotificationList();
                },
                error => {
                  nprogress.done();
                  this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications unread count.");
                }
              );
              this.$forceUpdate();
            },
            error => {
              nprogress.done();
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while marking as read");
            }
          );
        }
      });
    },
    // already accept decline transfer and then make it as unread
    alreadyTransferAcceptDecline() {
      window.$("#acceptDeclinedModal").modal("hide");
      if (!this.currentClickedNotification.read) {
        this.$api.markAsReadUserNotification(this.currentClickedNotification.userPortalNotificationId).then(
          () => {
            nprogress.done();
            this.$api.getUnreadCount(this.$route.params.studyId, this.user.id).then(
              response => {
                this.unreadCount = response.body.unreadCount;
                this.$forceUpdate();
                this.getSiteNotificationList();
              },
              error => {
                nprogress.done();
                this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications unread count.");
              }
            );
            this.$forceUpdate();
          },
          error => {
            nprogress.done();
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while marking as read");
          }
        );
      }
    },
    convertArrayStringHtml(colorCodingMetaDataOld, userDefinedParticipantId) {
      let PIDid;
      let colorCodingMetaData = colorCodingMetaDataOld;
      if (this.studyData.participantIdFormatConfigured.colorCodingEnable) {
        colorCodingMetaData = this.studyData.participantIdColorCodingMetaData;
        PIDid = userDefinedParticipantId.split("");
        for (let i = 0; i <= colorCodingMetaData.length - 1; i++) {
          for (let j = 0; j <= PIDid.length - 1; j++) {
            if (colorCodingMetaData[i].colorCodeCharacter - 1 == j) {
              switch (colorCodingMetaData[i].colorCodeCondition) {
                case "Is equal to":
                  if (colorCodingMetaData[i].colorCodeConditionValue == PIDid[j]) {
                    PIDid[j] = "<span style=' color: " + colorCodingMetaData[i].color + " '>" + PIDid[j] + "</span>";
                  }
                  break;
                case "Is not equal to":
                  if (colorCodingMetaData[i].colorCodeConditionValue != PIDid[j]) {
                    PIDid[j] = "<span style=' color: " + colorCodingMetaData[i].color + " '>" + PIDid[j] + "</span>";
                  }
                  break;
                case "None":
                  PIDid[j] = "<span style=' color: " + colorCodingMetaData[i].color + " '>" + PIDid[j] + "</span>";
                  break;
                default:
                  break;
              }
            }
          }
        }
        let PIDConv = "";
        for (let i = 0; i <= PIDid.length - 1; i++) {
          PIDConv = PIDConv + PIDid[i];
        }
        return PIDConv;
      } else {
        return userDefinedParticipantId;
      }
    },
    getStudyNotificationList() {
      nprogress.start();
      this.loading = true;
      this.$api.getStudyNotificationList(this.studyId, this.userId, this.pageNum, this.pageSize, this.sortValue, this.sortOrder, this.filter).then(
        response => {
          this.notificationList = response.body.notifications;
          this.totalPages = response.body.totalPages;
          this.enableNoData = this.notificationList.length == 0;
          nprogress.done();
          this.loading = false;
        },
        error => {
          nprogress.done();
          this.loading = false;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting study user notifications.");
        }
      );
    },
    getSiteNotificationList() {
      nprogress.start();
      this.loading = true;
      const portalType = this.isTestPortal ? PORTAL_TYPE.TEST : PORTAL_TYPE.LIVE;
      const options = {
        studyId: this.studyId,
        siteId: this.siteId,
        userId: this.userId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        sortValue: this.sortValue,
        sortOrder: this.sortOrder,
        filter: this.filter,
        env: portalType
      };
      this.$api.getSiteNotificationList(options).then(
        response => {
          this.notificationList = response.body.notifications;
          this.totalPages = response.body.totalPages;
          this.enableNoData = this.notificationList.length == 0;
          nprogress.done();
          this.loading = false;
        },
        error => {
          nprogress.done();
          this.loading = false;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting study user notifications.");
        }
      );
    },
    // used to read notification for transfer to,accepeted and declined by.
    unreadNotification(data) {
      if (data.notificationType === "PARTICIPANT_TRANSFER") {
        return false;
      }
      if (!data.read) {
        this.$api.markAsReadUserNotification(data.userPortalNotificationId).then(
          () => {
            nprogress.done();
            this.$api.getUnreadCount(this.$route.params.studyId, this.user.id).then(
              response => {
                this.unreadCount = response.body.unreadCount;
                this.$forceUpdate();
                this.getSiteNotificationList();
              },
              error => {
                nprogress.done();
                this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications unread count.");
              }
            );
            this.$forceUpdate();
          },
          error => {
            nprogress.done();
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while marking as read");
          }
        );
      }
    },
    //  To show full name of thread id
    toggleShowMore(item) {
      item.showMore = !item.showMore;
      this.$forceUpdate();
    },
    checkRoleAndGetDetails() {
      const user = localStorageService.getItem("userObj");
      this.userId = user.id;
      if (this.checkRole()) {
        this.siteId = user.siteIds[0];
        this.getSiteNotificationList();
        this.getSiteProfileNotifications();
      } else {
        this.getStudyNotificationList();
        this.getStudyProfileNotifications();
      }
    },
    checkRole() {
      if (this.user.userRole === "Pi" || this.user.userRole === "SubPi" || this.user.userRole === "StudyCoordinator" || this.user.userRole === "HomeHealth" || this.user.userRole === "CallCenter") {
        this.isSiteTeam = true;
        return true;
      }
      if (this.user.userRole === "Cra" || this.user.userRole === "Dm" || this.user.userRole === "Quality" || this.user.userRole === "CraUB") {
        this.isSiteTeam = false;
        return false;
      }
    },
    getStudyProfileNotifications() {
      nprogress.start();
      this.$api.getStudyTeamNotification(this.userId, this.studyId).then(
        response => {
          this.profileNotificationList = _.sortBy(response.body, "sortOrder");
          nprogress.done();
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting study user notifications.");
        }
      );
    },
    getSiteProfileNotifications() {
      const self = this;
      nprogress.start();
      self.$api.getSiteTeamNotification(this.studyId, this.siteId, this.userId).then(
        response => {
          const resp = response.body.filter(item => item.isEnabled);
          this.profileNotificationList = _.sortBy(resp, "sortOrder");
          nprogress.done();
        },
        error => {
          nprogress.done();
          self.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting site user notifications.");
        }
      );
    },
    onChangeFilter(filter) {
      this.filterText = filter.notificationText;
      this.filter = filter.notificationTypeId;
      this.pageNum = 1;
      this.checkRoleAndGetDetails();
    },
    // pagination
    prevPage(pageNum, totalPages) {
      const self = this;
      if (pageNum <= totalPages) {
        const promise = new Promise(function(resolve) {
          const currPage = pageNum - 1;
          resolve(currPage);
        });
        promise.then(function(pageNum) {
          self.pageNum = pageNum;
          if (self.checkRole()) {
            self.getSiteNotificationList();
          } else {
            self.getStudyNotificationList();
          }
        });
      }
    },
    nextPage(pageNum, totalPages) {
      const self = this;
      if (pageNum < totalPages) {
        const promise = new Promise(function(resolve) {
          const currPage = pageNum + 1;
          resolve(currPage);
        });
        promise.then(function(pageNum) {
          self.pageNum = pageNum;
          if (self.checkRole()) {
            self.getSiteNotificationList();
          } else {
            self.getStudyNotificationList();
          }
        });
      }
    },
    sortField(field) {
      let direction;
      field.ascOrder = !field.ascOrder;
      if (field.ascOrder == true) {
        field.ascOrder = true;
        field.descOrder = false;
        direction = "asc";
      } else {
        field.ascOrder = false;
        field.descOrder = true;
        direction = "desc";
      }
      this.sortValue = field.key;
      this.sortOrder = direction;
      if (this.checkRole()) {
        this.getSiteNotificationList();
      } else {
        this.getStudyNotificationList();
      }
    },
    goToParticipantProfile(item) {
      if (item.notificationType === "PARTICIPANT_TRANSFER") {
        return false;
      }
      nprogress.start();
      if (!item.read) {
        this.$api.markAsReadUserNotification(item.userPortalNotificationId).then(
          () => {
            nprogress.done();
            this.$api.getUnreadCount(this.$route.params.studyId, this.user.id).then(
              response => {
                this.unreadCount = response.body.unreadCount;
                this.$router.push({
                  name: `${this.isTestPortal ? TEST_PORTAL_SUFFIX : ""}participant-profile`,
                  params: { participantId: item.participantId }
                });
                this.$forceUpdate();
              },
              error => {
                nprogress.done();
                this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications unread count.");
              }
            );
            this.$forceUpdate();
          },
          error => {
            nprogress.done();
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while mark as read");
          }
        );
      } else {
        this.$router.push({
          name: `${this.isTestPortal ? TEST_PORTAL_SUFFIX : ""}participant-profile`,
          params: { participantId: item.participantId }
        });
      }
    },
    notificationDateFilter(value) {
      const date = moment(value);
      if (moment().diff(date, "days") >= 1) {
        return date.fromNow(); // '2 days ago' etc.
      }
      return date.calendar().split(" ")[0];
    }
  }
};
</script>

<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style scoped lang="scss" src="@/assets/dot-streaching-loader.scss"></style>
<style scoped lang="scss">
.notifications {
  width: 163px;
  height: 21px;
  font-family: Roboto-Regular;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  padding-bottom: 35px;
  padding-left: 0px;
}
.notification-grid {
  width: 100%;
  min-height: 805px;
  background-color: #ffffff;
}
.pagination {
  min-width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 11px !important;
}
.pagination2 {
  min-width: 40px;
  height: 32px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}
.disabledPagination {
  pointer-events: none;
}
.arrow-icon {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #d8d8d8;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #d8d8d8;
}
.position-absolute {
  position: absolute;
}
.bottom-0 {
  bottom: 0px;
}
.display-inline-flex {
  display: inline-flex !important;
}
.head-section {
  font-family: Roboto-Regular;
  font-size: 11px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #b0bac9;
}
.sortDown {
  position: absolute;
  padding-left: 4px;
  padding-top: 3px;
}
.sortUp {
  position: absolute;
  margin-top: -3px;
  padding-left: 4px;
}
.sortUp,
.sortDown {
  cursor: pointer;
  color: #666769;
  &.disable-icon {
    color: #a8a8a8;
  }
  i {
    font-size: 11px;
  }
}
.ICNNavNotificationOn {
  width: 15.4px;
  height: 18.1px;
  object-fit: contain;
  margin-top: -6px;
}
.participant-Id {
  width: 140px;
  height: 16px;
}
.thread-Id {
  width: 138.1px;
  height: 16px;
}
.text-info {
  color: #4c8ce4 !important;
  cursor: pointer;
  font-size: 14px;
  font-family: Roboto-Regular;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}
.pb-30 {
  padding-bottom: 30px !important;
  padding-top: 86px !important;
}
.width-119 {
  width: 119px;
}
.width-180 {
  width: 180px;
}
.table th {
  padding: 0.75rem;
  vertical-align: top;
}
.col-12 {
  padding-right: 0px;
  padding-left: 0px;
}
.box {
  width: 339px;
  height: 37px;
  border-radius: 3px;
  border: solid 1px #d3dfe4;
  background: #fff;
  z-index: -1;
  display: inline-block;
}
.All-notifications {
  width: 301px;
  height: 30px;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4a4a4a !important;
}
.Filter-by-status {
  width: 319px;
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #b0bac9 !important;
  background: #fff;
  border: none;
}
.Filter-by-status-1 {
  width: 319px;
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #666669 !important;
  background: #fff;
  border: none;
  cursor: pointer;
}
.none {
  cursor: none;
}
.notify-container {
  padding: 12px 25px 30px 227px;
}
.Content {
  width: 254px;
  height: 18.5px;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #c5d1d6;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #f7f7f7 !important;
}
.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 2px solid #e9ecef;
  margin: 9px 10px 1px 26px;
  color: #b0bac9;
}
.dropdown-menu.show {
  width: 354px;
  top: -38px !important;
  left: -3px !important;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
}
.dropdown-menu > input {
  background-color: transparent;
  border: none;
}
.dropdown-menu > input:focus {
  outline: none;
}
.dropdown-menu > a:hover {
  background-color: #ffffff;
}
.pl-right {
  float: right;
}
.pl-left {
  float: left;
}
.table-content-color {
  color: #4a4a4a;
  height: 55px !important;
}
.unread-row {
  width: 1008.2px;
  height: 40px;
  background-color: rgba(126, 203, 247, 0.1);
}
i.fa.fa-caret-down {
  color: #b0bac9;
}
.stage {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 250px 0px 0 550px;
  margin: 0 -5%;
  overflow: hidden;
}
.pr-10 {
  position: absolute;
  padding-right: 11px !important;
}
.caret-down-icon {
  background-image: url(/static/img/caret-down.png);
  background-position: 296px -1px;
  background-repeat: no-repeat;
}
.emptyGrid {
  padding-top: 150px;
  height: 100px;
  position: absolute;
  left: 45%;
  margin-left: -50px;
  font-family: Roboto-Medium;
  font-size: 17px;
}
.width-70 {
  width: 70px;
}
.emptyGrid {
  padding-top: 150px;
  height: 100px;
  position: absolute;
  left: 42%;
  margin-left: -50px;
  color: #9b9b9b;
}
.fa-angle-down {
  font-size: 12px !important;
  font-weight: normal !important;
  font-family: "FontAwesome" !important;
}
.fa-angle-up {
  font-size: 12px !important;
  font-weight: normal !important;
  font-family: "FontAwesome" !important;
}
.fa-angle-left {
  font-size: 22px !important;
  font-weight: normal !important;
  font-family: "FontAwesome" !important;
}
.fa-angle-right {
  font-size: 22px !important;
  font-weight: normal !important;
  font-family: "FontAwesome" !important;
}
// transfer participant history
@media (min-width: 576px) {
  #transferParticipantModal .modal-dialog {
    width: 339px;
    margin: 1.75rem auto;
  }
}

#transferParticipantModal .modal-title {
  font-family: Roboto;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
  padding: 24px 11px 0 11px;
}

#transferParticipantModal .modal-body {
  padding-top: 0 !important;
  position: relative;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem;
}
#transferParticipantModal .table {
  width: 100%;
  max-width: 100%;
  margin-bottom: none;
}
#transferParticipantModal .table th {
  font-family: Roboto;
  font-size: 12px;
  font-weight: bold;
  color: #b0bac9;
  border-bottom: None;
  padding-top: 10px;
  padding-left: 15px;
}
#transferParticipantModal .table td {
  font-family: Roboto;
  font-size: 14px;
  color: #4a4a4a;
  padding: 4px 10px !important;
  border: none !important;
}
#transferParticipantModal .table th {
  border-top: none;
  padding: 0 10px 0;
}
.input-title {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: left;
  color: #b0bac9;
}
.btn-decline {
  font-size: 14px;
  padding: 8px 20px;
  color: #666669;
  border-radius: 4px;
  background-color: #e3e3e3;
}
.btn-accept {
  font-size: 14px;
  padding: 8px 20px;
  color: #ffffff;
  border-radius: 4px;
  background-color: #4c8ce4;
}
.btn-ok {
  font-size: 14px;
  color: #ffffff;
  border-radius: 4px;
  background-color: #4c8ce4;
}
.numberID {
  border-radius: 4px;
  width: 20px;
  height: 23px;
  padding: 4px 6px 3px;
  border-radius: 4px;
  background-color: #1e8fe1;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  color: #ffffff;
}
.width-540 {
  width: 540px;
}
.transfer-table-wrapper {
  background-color: #eaf0f4;
  padding: 10px 5px 5px;
}
.tarnsfer-table-div {
  background-color: #eaf0f4;
  width: 100%;
  height: 125px !important;
  overflow: auto;
  margin: 0 auto;
}
.tarnsfer-table-div {
  overflow: auto;
}
.tarnsfer-table-div::-webkit-scrollbar {
  width: 6px; /* width of the entire scrollbar */
}
.tarnsfer-table-div::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}
.tarnsfer-table-div::-webkit-scrollbar-thumb {
  background-color: #c5d1d6; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid transparent; /* creates padding around scroll thumb */
}
</style>
